define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Timer = (function () {
        function Timer(inputId, outputId) {
            this.inputElement = document.querySelector("#" + inputId);
            this.outputElement = document.querySelector("#" + outputId);
            this.intervalId = null;
            this.remainingTime = 0;
        }
        Timer.prototype.parseTimeString = function (timeString) {
            var _a = timeString.split(':').map(Number), hours = _a[0], minutes = _a[1], seconds = _a[2];
            return hours * 3600 + minutes * 60 + seconds;
        };
        Timer.prototype.formatTime = function (seconds) {
            var hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
            var minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
            var secs = String(seconds % 60).padStart(2, '0');
            return hours + ":" + minutes + ":" + secs;
        };
        Timer.prototype.start = function () {
            var _this = this;
            if (this.intervalId) {
                console.warn('Timer is already running!');
                return;
            }
            var inputTime = this.inputElement.value;
            if (!/^\d{2}:\d{2}:\d{2}$/.test(inputTime)) {
                alert('Please enter a valid time in HH:mm:ss format.');
                return;
            }
            this.remainingTime = this.parseTimeString(inputTime);
            if (this.remainingTime <= 0) {
                alert('Time must be greater than 0.');
                return;
            }
            this.updateDisplay();
            this.intervalId = setInterval(function () {
                _this.remainingTime--;
                if (_this.remainingTime <= 0) {
                    _this.stop();
                }
                _this.updateDisplay();
            }, 1000);
        };
        Timer.prototype.stop = function () {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        };
        Timer.prototype.updateDisplay = function () {
            this.outputElement.textContent = this.formatTime(this.remainingTime);
        };
        return Timer;
    }());
    exports.default = Timer;
});
